<template>
<div>

  <Head></Head>
  <div class="bg-red" style="min-width:1220px;">
    <div class="align-center flex-relative margin-center width" style="height: 46px;padding-left: 82px;">

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt active" style="height: 100%;line-height: 46px;cursor: pointer;" @click="clickOnButton('home')">首页</div>

      <!-- <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='idear'}" @click="clickOnButton('idear')">思政课程</div> -->

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='talk'}" @click="clickOnButton('talk')">百场讲坛</div>

      <div class="padding-l-r-20 font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='special'}" @click="clickOnButton('special')">专题学习</div>
      <div class="padding-l-r-20 font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='course'}" @click="clickOnButton('course')">课程思政</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='lcountry'}" @click="clickOnButton('lcountry')">爱党爱国</div>

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='culture'}" @click="clickOnButton('culture')">传统文化</div>

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='redread'}" @click="clickOnButton('redread')">红色阅读</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='redfilm'}" @click="clickOnButton('redfilm')">红色电影</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='information'}" @click="clickOnButton('information')">资讯</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='courseDownload'}" @click="clickOnButton('courseDownload')">课件下载</div>

    </div>
  </div>
  <div class="container" v-if="video_info">
    <!-- 视频播放器 start -->
    <div class="video">
      <div class="video-wrap">
        <!-- <video id="videoElement" controls autoplay height="500px" width="890px"></video> -->
        <div v-if="videoFormat!='swf'" id="dplayer" style="backgroundcolor: #262930;height:500px;width:890px;"></div>
        <div class="video-menu">
          <div class="v-name">
            <p class="text p-left">{{ video_info.Title }}</p>
          </div>

          <div class="tabs flex">
            <div :class="currentTab == 0 ? 'sel' : 'none'" @click="tabSelect(0)">
              选集
            </div>
            <div :class="currentTab == 1 ? 'sel' : 'none'" @click="tabSelect(1)">
              简介
            </div>
            <div :class="currentTab == 2 ? 'sel' : 'none'" @click="tabSelect(2)">
              作者
            </div>
          </div>

          <!-- 视频选集 start -->
          <div v-if="currentTab == 0" class="v-items flex-sub">
            <div class="video-item" v-for="(item, index) in video_info.Videos" :class="playIndex == index ? 'vsel font-color-blue' : 'vunsel'" :key="index" @click="switchVideo(index)">
              <span :class="playIndex == index ? 'font-color-blue' : 'font-color-999'">{{ item.VideoTitle }}</span>
            </div>
          </div>
          <!-- 视频选集 end -->

          <!-- 课程简介 start -->
          <div v-else-if="currentTab == 1" class="video-des flex-sub">
            {{ video_info.Introduction }}
          </div>
          <!-- 课程简介 end -->

          <!-- 作者信息 start -->
          <div v-else-if="currentTab == 2" class="video-author flex-sub flex">
            <el-image class="lecturer-image" style="width:50px;height:50px; border-radius: 25px;" :src="video_info.Videos[playIndex].LecturerImage" fit="cover"></el-image>
            <div class="lecturer-content flex-sub">
              <p class="lecturer p-left">
                {{ video_info.Videos[playIndex].Lecturer }}
              </p>
              <h4 class="lecturer-info">
                {{ video_info.Videos[playIndex].LecturerIntroduce }}
              </h4>
            </div>
          </div>
          <!-- 作者信息 end -->
        </div>
      </div>
    </div>

    <!-- 视频播放器 end -->

    <div class="video-bottom">
      <!-- 视频下方推荐课程 start -->
      <div class="rec-left">
        <h3 class="lf-title">推荐课程</h3>
        <div class="flex flex-wrap rc">
          <div class="item" v-for="(item, index) in rec_topic_list" :key="item.Id" @click="toOterPlay(index)">
            <!-- <el-image class="lf-image" :src="item.Image" fit="cover"></el-image> -->
            <div class="lf-image" :style="{backgroundImage:'url('+item.Image+')'}"></div>
            <p :title="item.Title" class="lf-cor-title p-left">{{ item.Title }}</p>
            <p :title="item.Lecturer" class="lf-cor-author p-left">主讲：{{ item.Lecturer }}</p>
          </div>
        </div>
      </div>
      <!-- 视频下方推荐课程 end -->

      <div class="rec-right flex flex-direction">
        <!-- 视频右下方图书推荐 无PPT下载 start -->
        <div class="rec-right-wrap" v-if="!video_info.PPTUrl && !video_info.ManuscriptsUrl">
          <h3 class="rg-head-t">图书推荐</h3>
          <div class="item" v-for="(item, index) in rec_book_list" :key="item.Id" @mouseover="mouserOver(index)">
            <div v-if="index != mouse_over_index" class="normal">
              {{ index + 1 }}. {{ item.Title }}
            </div>
            <div v-else class="over">
              <span class="index">{{ index + 1 }}.</span>
              <el-image style="width: 86px; height: 102px; margin-left: 9px" :src="item.Image" fit="cover"></el-image>
              <div class="values flex-sub" style="margin-top: 12px; flex-direction:column; justify-content:space-between; display:flex;">
                <p :title="item.Title" class="tit p-left">{{ item.Title }}</p>
                <div class="flex justify-between">
                  <p :title="item.Author" class="author p-left">作者：{{ item.Author }}</p>
                  <div class="down-btn" @click="downloadBook(index)">
                    <img src="../../assets/img/videoPlay/icon-video-red.png" style="width: 13px; height: 13px; margin-right: 2px" />
                    下载
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频右下方图书推荐 无PPT下载 end -->

        <!-- 视频右下方图书推荐 有PPT下载 start -->
        <div v-else>
          <div class="resource">
            <h3 class="title">课程资料</h3>
            <div class="flex">
              <div class="book-btn flex flex-center" @click="donwnPPT">
                <img src="../../assets/img/videoPlay/icon-video-ppt.png" style="width: 15px; height: 14px; margin-right: 2px" />下载PPT
              </div>
              <div class="book-btn flex flex-center" @click="downDoc">
                <img src="../../assets/img/videoPlay/icon-video-gray.png" style="width: 13px; height: 12px; margin-right: 2px" />
                下载文稿
              </div>
            </div>
          </div>

          <div class="with-down-wrap">
            <h3 class="rg-head-t">图书推荐</h3>
            <div class="item" v-for="(item, index) in rec_book_list" :key="item.Id" @mouseover="mouserOver(index)">
              <div v-if="index != mouse_over_index" class="normal">
                {{ index + 1 }}. {{ item.Title }}
              </div>
              <div v-else class="over">
                <span class="index">{{ index + 1 }}.</span>
                <el-image style="width: 86px; height: 102px; margin-left: 9px;" :src="item.Image" fit="cover"></el-image>
                <div class="values flex-sub" style="margin-top: 12px; flex-direction:column; justify-content:space-between; display:flex;">
                  <p :title="item.Title" class="tit p-left">{{ item.Title }}</p>
                  <div class="flex justify-between" style="margin-top: 24px">
                    <h3 :title="item.Author" class="author">作者：{{ item.Author }}</h3>
                    <div class="down-btn" @click="downloadBook(index)">
                      <img src="../../assets/img/videoPlay/icon-video-red.png" style="width: 13px; height: 13px; margin-right: 2px" />
                      下载
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频右下方图书推荐 有PPT下载 end -->
      </div>
    </div>
  </div>

  <Bottom></Bottom>
</div>
</template>

<script>
// import flvjs from 'flv.js/dist/flv.min.js'
import common from '@/utils/common.js'

import flvjs from 'flv.js/dist/flv.min.js'
import DPlayer from 'dplayer'
// import common from "@/utils/common.js";
window.flvjs = flvjs
export default {
  name: 'Video',
  data () {
    return {
      title: 'home',
      flvPlayer: null,
      courseId: 0,
      videoId: 0,
      currentTab: 0,
      reqData: null,
      playSrc: '',
      playIndex: 0,
      rec_book_list: [],
      rec_topic_list: [],
      video_info: {},
      mouse_over_index: 0,
      videoFormat: 'mp4',
      sizheng: 'n',

      videoFormat: '',
      dplayer: null,
      stayTime: 0,
      timer: null
    }
  },
  watch: {
    playSrc () {
      // if (flvjs.isSupported()) {
      //   var videoElement = document.getElementById('videoElement')
      //   if (this.flvPlayer != null) {
      //     // console.log('销毁一下flvplayer')
      //     this.flvPlayer.unload()
      //     this.flvPlayer.detachMediaElement()
      //     this.flvPlayer.destroy()
      //     this.flvPlayer = null
      //   }
      //   this.flvPlayer = flvjs.createPlayer({
      //     type: this.videoFormat,
      //     isLive: true,
      //     hasAudio: false,
      //     url: this.playSrc
      //   })
      //   this.flvPlayer.on("durationchange", function (res) {
      //     console.log('-------------------');
      //   });
      //   this.flvPlayer.attachMediaElement(videoElement)
      //   this.flvPlayer.load()
      //   this.flvPlayer.play()
      // }
      if (this.playSrc.indexOf('.mp4') > 0) {
        this.videoFormat = 'auto'
      } else if (this.playSrc.indexOf('.flv') > 0) {
        this.videoFormat = 'flv'
      } else if (this.playSrc.indexOf('.swf') > 0) {
        this.videoFormat = 'swf'
      }
      if (this.videoFormat == 'swf') {
        this.dplayer.destroy()
        this.dplayer = null
        clearInterval(this.timer)
        this.timer = null
        this.stayTime = 0
        return
      }

      var that = this
      if (this.dplayer != null) {
        // this.dplayer.$off('durationchange')
        // this.dplayer.$off('timeupdate')
        this.dplayer.destroy()
        this.dplayer = null
        clearInterval(this.timer)
        this.timer = null
        this.stayTime = 0
      }
      this.dplayer = new DPlayer({
        container: document.getElementById('dplayer'),
        autoplay: true,
        theme: '#23CEBC',
        loop: true,
        lang: 'zh-cn',
        screenshot: true,
        hotkey: true,
        preload: 'auto',
        mutex: true,
        video: {
          url: that.playSrc,
          type: that.videoFormat
          // pic: that.video_info.Videos[that.playIndex].VideoImage,
        }
      })
      this.dplayer.on('durationchange', function (res) {
        // that.addPlayLog();
        that.timer = setInterval(() => {
          that.stayTime = that.stayTime + 1
        }, 1000)
      })
      document.querySelector('#dplayer').oncontextmenu = () => {
        document.querySelector('.dplayer-menu').style.display = 'none'
        document.querySelector('.dplayer-mask').style.display = 'none'
        return false
      }
      // if (this.video_info.Videos[this.playIndex].LastPlayTime > 0) {
      //   this.dplayer.seek(this.video_info.Videos[this.playIndex].LastPlayTime);
      // }
      // window.history.replaceState(
      //   "",
      //   "",
      //   this.video_info.Videos[this.playIndex].Id
      // );
    }
  },
  mounted () {
    window.addEventListener('beforeunload', (e) => this.addPlayVideoLog())
  },
  created () {
    // this.loginSuce()
    var token = common.getCookie('utoken')
    if (token != '') {
      this.loginSuce()
    } else {
      localStorage.setItem('islogin_httpurl', window.location.href)
      this.$router.replace({
        name: 'black',
        params: {
          isfirst: 'first',
          states: 'login'
        }
      })
    }
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
    this.addPlayVideoLog()
  },
  methods: {

    addPlayVideoLog () {
      let v = this.video_info.Videos[this.playIndex]
      // console.log(common.userBase);
      let params = {

        logId: 'sz_' + new Date().getTime(),
        productIds: '10',
        customerCode: common.userBase.ComCode,
        customerName: common.userBase.ComName,
        customerId: common.userBase.ComId,
        userId: common.userBase.UserId,
        userName: common.userBase.UserName,
        sourceType: 'PC',
        catalogId: this.video_info.CatalogIds,
        catalogData: this.video_info.CatalogNames,
        courseId: this.video_info.Id,
        courseName: this.video_info.Title,
        videoId: v.VideoId,
        videoName: v.VideoTitle,
        watchDuration: this.stayTime,
        watchPoint: this.dplayer.video.currentTime == null ? 0 : parseInt(this.dplayer.video.currentTime),
        duration: this.dplayer.video.duration == null ? 0 : parseInt(this.dplayer.video.duration),
        actId: 0

      }

      this.postRequestVisit('Api/v1/Log/PlayLog', params).then((res) => {
        // console.log(res)
      })
    },
    clickOnButton: function (des) {
      if (des == 'courseDownload') {
        window.open('http://h5.cdn.bjadks.com/website/sz-zt/Courseware/index.html')
        return
      }
      this.$router.push({
        name: des
      })
    },

    loginSuce () {
      // this.courseId = this.$route.params.courseId
      // this.requestVideoInfo()
      // this.requestRecTop()
      // this.requestRecBook()

      this.courseId = this.$route.params.courseId
      this.videoId = this.$route.params.videoId || 0
      this.sizheng = this.$route.params.sizheng || 'n'
      if (this.sizheng != 'n') {
        this.handleSizhengData()
        this.requestRecTop()
      } else {
        this.requestVideoInfo()
        this.requestRecTop()
      }
    },
    tabSelect: function (index) {
      this.currentTab = index
    },
    switchVideo: function (index) {
      this.addPlayVideoLog()
      let url = this.video_info.Videos[index].VideoUrl
      if (url.indexOf('.mp4') > 0) {
        this.videoFormat = 'mp4'
      } else if (url.indexOf('.flv') > 0) {
        this.videoFormat = 'flv'
      }
      this.playSrc = url
      if (!this.playSrc) {
        this.$message.error('暂无权限查看该视频，请在机构IP范围内使用！')
      }
      this.playIndex = index
    },
    requestVideoInfo: function () {
      var that = this
      this.getRequest('api/v1/courses/' + this.courseId + '?ComCode=' + common.userBase.ComCode).then(data => {
        if (data.IsSuccess) {
          that.video_info = data.Data
          if (that.videoId == 0) {
            that.playSrc = that.video_info.Videos[0].VideoUrl
            if (!that.playSrc) {
              that.$message.error('暂无权限查看该视频，请在机构IP范围内使用！')
            }
          } else {
            that.video_info.Videos.forEach((item, index) => {
              if (item.VideoId == that.videoId) {
                that.playSrc = item.VideoUrl
                that.playIndex = index
                if (!that.playSrc) {
                  that.$message.error('暂无权限查看该视频，请在机构IP范围内使用！')
                }
              }
            })
          }
          document.title = data.Data.Title
          that.requestRecBook()
        } else {
          that.$message.error(data.Message)
        }
      })
    },
    requestRecTop () {
      var that = this
      this.getRequest('api/v1/recommend/courses?courseId=' + this.courseId).then(data => {
        if (data.IsSuccess) {
          that.rec_topic_list = data.Data
        } else {
          that.$message.error(data.Message)
        }
      })
    },
    requestRecBook: function () {
      var that = this
      this.getRequest('api/v1/recommend/library', {
        courseId: this.courseId,
        qty: this.video_info.PPTUrl ? 3 : 5
      }).then(data => {
        if (data.IsSuccess) {
          that.rec_book_list = data.Data
        } else {
          that.$message.error(data.Message)
        }
      })
    },

    mouserOver: function (index) {
      this.mouse_over_index = index
    },
    downloadBook: function (index) {
      window.location.href = this.rec_book_list[index].DownloadUrl
    },
    handleSizhengData: function () {
      var that = this
      var vary = []
      var data = {}
      common.listData.forEach((item, index) => {
        if (item.Id == that.courseId) {
          data['Introduction'] = item.courseDes
          data['Title'] = item.title
          item.listCourse.forEach(sitem => {
            sitem.listVideo.forEach(vitem => {
              let p = {
                VideoId: vitem.videoId,
                VideoTitle: vitem.videoName,
                VideoUrl: vitem.videoPath,
                Lecturer: vitem.author,
                LecturerImage: vitem.authorImg,
                LecturerIntroduce: vitem.authorDes
              }
              vary.push(p)
            })
          })
        }
      })
      data['Videos'] = vary
      this.video_info = data
      if (this.videoId > 0) {
        for (var i = 0; i < vary.length; i++) {
          let item = vary[i]

          if (item.VideoId == this.videoId) {
            this.switchVideo(i)
            break
          }
        }
      } else {
        this.switchVideo(0)
      }
      // console.log(this.video_info)
      this.requestRecBook()
    },
    toOterPlay: function (index) {
      this.addPlayVideoLog()
      this.$router.replace({
        name: 'video',
        params: {
          courseId: this.rec_topic_list[index].Id
        }
      })
      this.playSrc = ''
      this.currentTab = 0
      this.playIndex = 0
      this.mouse_over_index = 0
      this.courseId = this.rec_topic_list[index].Id
      this.rec_book_list = []
      this.rec_topic_list = []
      // this.isLogin()
      this.loginSuce()
    },
    donwnPPT: function () {
      window.location.href = this.video_info.PPTUrl
    },
    downDoc: function () {
      window.location.href = this.video_info.ManuscriptsUrl
    }
  }
}
</script>

<style scoped>
body {
  background-color: #fff;
}

h3 {
  text-align: left;
}

.p-left {
  text-align: left;
}

.container .video {
  background-color: #000;
  height: 558px;
}

.active {
  color: #ffffff;
  background: #af0000;
}

.navt:hover {
  color: #ffffff;
  background: #af0000;
}

.container .video-wrap {
  display: flex;
  background-color: #000;
  width: 1220px;
  margin: 0 auto;
  padding: 30px 0 28px;
  height: 558px;
}

.video-wrap .v-name {
  margin: 0 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 10px 0;
}

.video-wrap .v-name .text {
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
}

.container .video-wrap .video-menu {
  background-color: #212121;
  display: inline-block;
  height: 500px;
  width: 315px;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
}

.video-menu .tabs {
  height: 45px;
  margin-left: 15px;
  margin-top: 10px;
}

.video-menu .tabs div {
  font-size: 14px;
  line-height: 45px;
  padding: 0 5px;
  margin-right: 20px;
  color: #fff;
  display: inline-block;
  cursor: pointer;
}

.video-menu .tabs .sel {
  color: #4a9cfa;
}

.video-menu .tabs .none {
  color: #fff;
}

.video-menu .v-items {
  overflow: scroll;
}

.video-menu .v-items::-webkit-scrollbar,
.video-menu .video-des::-webkit-scrollbar,
.video-menu .video-author::-webkit-scrollbar {
  display: none;
}

.video-item {
  margin: 0 10px 10px;
  padding: 10px 10px;
  background-color: #212121;
  cursor: pointer;
  text-align: left;
}

.video-menu .vsel {
  background-color: #1a1a1a;
  color: #4a9cfa;
}

.video-menu .vunsel {
  background-color: #212121;
  color: #fff;
}

.video-item span {
  font-size: 14px;
  line-height: 20px;
}

.video-des {
  margin: 0 10px 10px;
  padding: 10px;
  font-size: 12px;
  line-height: 20px;
  color: #999;
  background-color: #1a1a1a;
  text-align: left;
  overflow: scroll;
}

.video-author {
  margin: 0 10px 10px;
  padding: 15px;
  background-color: #1a1a1a;
  overflow: scroll;
}

.video-author .lecturer-image {
  width: 50px;
  height: 50px;
  border-radius: 25px;
}

.video-author .lecturer-content {
  margin-left: 18px;
}

.video-author .lecturer-content .lecturer {
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  margin-top: 5px;
}

.video-author .lecturer-content .lecturer-info {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  text-align: left;
  margin-top: 10px;
}

.video-bottom {
  width: 1220px;
  height: 460px;
  display: flex;
  margin: 20px auto 0;
}

.video-bottom .rec-left {
  width: 889px;
  margin-right: 14px;
  height: 462px;
  display: inline-block;
  padding: 0 18px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

.video-bottom .rec-left .rc {
  overflow: hidden;
}

.video-bottom .rec-left .lf-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 52px;
}

.video-bottom .rec-left .item {
  margin-bottom: 28px;
  display: inline-block;
  margin-right: 19px;
  cursor: pointer;
}

.video-bottom .rec-left .item .lf-image {
  width: 198px;
  height: 118px;
  background-size: cover;
  background-repeat: no-repeat;
}

.video-bottom .rec-left .item .lf-cor-title {
  font-size: 16px;
  color: #333;
  line-height: 18px;
  margin-top: 15px;
  max-width: 198px;
  max-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}

.video-bottom .rec-left .item .lf-cor-author {
  font-size: 12px;
  line-height: 18px;
  max-height: 18px;
  margin-top: 3px;
  max-width: 198px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}

.video-bottom .rec-left .item:nth-child(4n) {
  margin-right: 0;
}

.video-bottom .rec-right {
  width: 317px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0);
}

.video-bottom .rec-right .rec-right-wrap {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  height: 462px;
  background-color: #fff;
}

.video-bottom .rec-right .rg-head-t {
  height: 54px;
  margin: 0 20px;
  border-bottom: 1px solid #ebebeb;
  font-size: 16px;
  text-align: left;
  line-height: 55px;
  font-weight: bold;
  color: #000;
}

.video-bottom .rec-right .normal {
  height: 64px;
  color: #333333;
  font-size: 14px;
  line-height: 64px;
  border-bottom: 1px solid #ebebeb;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
  text-align: left;
  margin: 0 18px;
}

.video-bottom .rec-right .over {
  display: flex;
  align-content: flex-start;
  height: 144px;
  border-bottom: 1px solid #ebebeb;
  margin: 0 18px;
  padding: 21px 0;
}

.video-bottom .rec-right .over .values {
  margin-left: 10px;
}

.video-bottom .rec-right .over .values .tit {
  font-size: 14px;
  line-height: 23px;
  max-height: 46px;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #333;
}

.video-bottom .rec-right .over .index {
  font-size: 16px;
}

.video-bottom .rec-right .over .values .author {
  font-size: 12px;
  line-height: 16px;
  max-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
  color: #999;
}

.video-bottom .rec-right .values .down-btn {
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: 12px;
  color: #d30000;
  cursor: pointer;
  width: 70px;
}

.video-bottom .rec-right .resource {
  background-color: #fff;
  height: 104px;
  padding: 0 17px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
}

.video-bottom .rec-right .resource .title {
  line-height: 49px;
}

.video-bottom .rec-right .resource .buttons {
  display: flex;
}

.video-bottom .rec-right .resource .book-btn {
  width: 96px;
  height: 32px;
  background-color: #e9eaea;
  border-radius: 4px;
  color: #666;
  line-height: 32px;
  margin-right: 20px;
  cursor: pointer;
  margin-right: 20px;
}

.video-bottom .rec-right .with-down-wrap {
  height: 342px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  /* overflow: hidden; */
}

.video-bottom .rec-right .item:nth-last-child(1) .normal,
.video-bottom .rec-right .item:nth-last-child(1) .over {
  border: none;
}

video:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/views/video/video.vue